export default "__VITE_ASSET__CizKPd_1__"